const MEBIBYTE = 1024 ** 2;
const GIBIBYTE = 1024 ** 3;

export function formatStorageBytes(bytes: number) {
  if (!Number.isFinite(bytes) || bytes <= 0) return "0 MB";

  if (bytes >= GIBIBYTE) {
    const gigabytes = bytes / GIBIBYTE;
    return `${gigabytes >= 100 ? gigabytes.toFixed(0) : gigabytes.toFixed(1)} GB`;
  }

  const megabytes = bytes / MEBIBYTE;
  return `${megabytes >= 10 ? megabytes.toFixed(0) : megabytes.toFixed(1)} MB`;
}

export function storageCapacityLabel(usage: number, quota: number) {
  const used = formatStorageBytes(usage);
  return quota > 0 ? `${used} / ${formatStorageBytes(quota)} local` : `${used} local`;
}

export function storageCapacityDescription(usage: number, quota: number) {
  const used = formatStorageBytes(usage);
  return quota > 0
    ? `${used} used of ${formatStorageBytes(quota)} currently available to TBLTOP. The browser may adjust the available total over time.`
    : `${used} used by TBLTOP. The browser has not reported an available total yet.`;
}
